import { useEffect, useState } from "react";
import DataTable from "../../../components/table/data/DataTable";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useContactColumns } from "../../../hooks/useTableColumns";
import Toolbar from "../../../components/toolbar/Toolbar";
import DownloadTable from "../../../utils/download/downloadDataTable";
import { IFilter } from "../../../components/table/data/filter/DataFilter";
import IContact from "../../../models/contact";
import contactService from "../../../services/contact/ContactService";


const ContactPage = () => {
  const columns = useContactColumns();
  const navigate = useNavigate();
  const [isFilterActive, setIsFilterActive] = useState<boolean>(true);
  const [contacts, setContacts] = useState<IContact[]>([]);
  const { t } = useTranslation();

  const [filteredRows, setFilteredRows] = useState(contacts);
  const [selectedFilters, setSelectedFilters] = useState<
    Map<string, IFilter>
  >(new Map());

  const visibleFilters: string[] = [];
  selectedFilters.forEach((filter, field) => {
    if (!filter.isActive || !filter.request) return;
    const column = columns.find((column) => column.field === field);
    visibleFilters.push(`${column?.headerName}: ${t(`periodical:filter.${filter.type}`)} ${filter.request}`);
  });

  const downloadTable = new DownloadTable("user", filteredRows, columns, t("table.user.title"), visibleFilters)

  useEffect(() => {
    contactService.GetContactsByCompany().then(setContacts)
  }, []);

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Toolbar
        onFilterClick={() => setIsFilterActive((old) => !old)}
        onCreate={() => navigate("add")}
        isFilterActive={isFilterActive}
        downloadButtons={[
          { label: "Excel", onClick: () => downloadTable.GetExcel(t("header.exportedBy"), t("header.exportDate")) },
          { label: "CSV", onClick: () => downloadTable.GetCSV() },
          { label: "PDF", onClick: () => downloadTable.GetPDF(t("header.exportedBy"), t("header.exportDate")) }
        ]}
      />

      <DataTable
        dense
        disableFiltrer={!isFilterActive}
        rows={contacts}
        columns={columns}
        onRowClick={(row) =>
          navigate("edit", { state: { ...row } })
        }
        getRowNavTo={(row) => "edit"}
        onSetFilter={(filteredRows, selectedFilters) => {
          setFilteredRows(filteredRows)
          setSelectedFilters(selectedFilters)
        }}
      />
    </Box>
  );
};
export default ContactPage;
